/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, members: NonNullable<unknown> }} Pricing_Titan_Size_OverInputs */



/**
* | output |
* | --- |
* | "{price} over {members} members" |
*
* @param {Pricing_Titan_Size_OverInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_titan_size_over = /** @type {((inputs: Pricing_Titan_Size_OverInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Titan_Size_OverInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.price} — свыше ${i?.members} участников`)
	return /** @type {LocalizedString} */ (`${i?.price} over ${i?.members} members`)
});